import React from 'react';
import {View} from 'MWC';
import PropTypes from 'prop-types';
import tpl from '../../templates/landing/gold.jsx';
import CreditCardsModel from '../../models/creditCards.m';
import {apiback} from '../../../../config';
import widgetsHelper from 'utils/getWidget.helper';

const goldCard = 'universal_gold_card';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    toggleMode = mode => {
        this.setState({mode: mode});
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            model: {},
            isUtm: new URLSearchParams(this.props.location.search).get('utm_source'),
            mode: 'info',
            where_by: ['path'],
            search_by: [location.pathname],
            widgets: []
        };

        this.crefs = {};
        this.widgetsHelper = widgetsHelper;
        return this;
    }

    componentWillMount() {
        this.widgetsHelper.getWidgets.call(this);
        fetch(apiback('CREDIT_CARDS'))
            .then(res => res.json())
            .then(json =>
                this.setState({
                    model: new CreditCardsModel(json.data[goldCard])
                })
            );
        // .catch(x => console.log('error:', x)); //todo добавить обработчик
    }

    static displayName = 'CardGold';

    static contextTypes = {
        app: PropTypes.object,
        history: PropTypes.object
    };
}
